import axios from 'axios';
import { getStudentsApiUrl } from '../config';

// Get token from localStorage
const getAuthHeader = () => {
    const token = localStorage.getItem('parentToken');
    return token ? { Authorization: `Bearer ${token}` } : {};
};

export const studentService = {
    // Get all enrolled students
    getEnrolledStudents: async (phone) => {
        const response = await axios.get(`${getStudentsApiUrl()}/enrolled`, {
            headers: getAuthHeader(),
            params: { contactNumber: phone }
        });
        return response.data;
    },

    // Search students by contact number or name
    searchStudents: async (query) => {
        const response = await axios.get(`${getStudentsApiUrl()}/search`, {
            params: { query: query },
            headers: getAuthHeader()
        });
        return response.data;
    },

    // Get student enrollment details by studentId
    getStudentEnrollment: async (studentId) => {
        const response = await axios.get(`${getStudentsApiUrl()}/enrollments/${studentId}`, {
            headers: getAuthHeader()
        });
        return response.data;
    }
};
